var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('NavigationLayout',{attrs:{"navigationBarStyle":{
    'border-bottom': '1px solid #e8e8e8',
  }}},[_c('div',{staticClass:"maintenance__wrapper",attrs:{"slot":"contents"},slot:"contents"},[_c('Maintenance')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }